<template>
  <div class="not-found d-flex flex-column align-center justify-center">
    <v-icon size="100" color="grey" class="mb-4">mdi-alert-circle-outline</v-icon>
    
    <h1 class="text-h3 mb-2">{{ t('errors.notFound') }}</h1>
    <p class="text-body-1 mb-8 text-center">
      A página que você está procurando não existe ou foi movida.
    </p>
    
    <div class="d-flex">
      <v-btn
        color="primary"
        size="large"
        :to="{ name: 'dashboard' }"
        prepend-icon="mdi-home"
        class="mr-4"
      >
        Ir para o Dashboard
      </v-btn>
      
      <v-btn
        variant="outlined"
        size="large"
        @click="$router.go(-1)"
        prepend-icon="mdi-arrow-left"
      >
        Voltar
      </v-btn>
    </div>
    
    <div class="mt-10">
      <div class="text-h6">{{ t('app.subtitle') }}</div>
      <div class="text-caption">Não consegue encontrar o que procura? Utilize nossa busca universal no topo da página.</div>
    </div>
    
    <!-- Easter egg blockchain animation -->
    <div class="blockchain-animation mt-10">
      <div 
        v-for="i in 8" 
        :key="i" 
        class="block"
        :style="{ animationDelay: `${i * 0.2}s` }"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView'
}
</script>

<style scoped>
.not-found {
  min-height: 80vh;
  padding: 48px 16px;
}

.blockchain-animation {
  display: flex;
  align-items: center;
  margin-top: 40px;
}

.block {
  width: 40px;
  height: 40px;
  background-color: var(--v-primary-base, #7E57C2);
  margin: 0 8px;
  border-radius: 4px;
  opacity: 0.2;
  animation: pulse 2s infinite;
  position: relative;
}

.block::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -12px;
  width: 8px;
  height: 2px;
  background-color: var(--v-primary-base, #7E57C2);
}

.block:last-child::after {
  display: none;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.2;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.2;
  }
}
</style>
